function looksLikeANumber(text: string): boolean {
  const parts = text.split(/[,.]/);

  if (parts.length > 1) {
    return parts
      .slice(1)
      .reduce((a: boolean, v: string): boolean => a && v.length === 3, true);
  }

  return true;
}

export function parseAmount(text: string): number | undefined {
  const textWithoutWhitespace = text.replace(/\s/g, "");
  const centsMatch = textWithoutWhitespace.match(/^([0-9,.]*\d)[.,](\d{1,2})$/);
  const dollarsMatch = textWithoutWhitespace.match(/^[0-9,.]+$/);

  let cents;
  let dollars;

  if (centsMatch && looksLikeANumber(centsMatch[1])) {
    const centsString = centsMatch[2];
    cents = Number(centsString) * (centsString.length === 1 ? 10 : 1);
    dollars = Number(centsMatch[1].replace(/[,.]/g, ""));
  } else if (dollarsMatch && looksLikeANumber(textWithoutWhitespace)) {
    cents = 0;
    dollars = Number(textWithoutWhitespace.replace(/[,.]/g, ""));
  } else {
    cents = NaN;
    dollars = NaN;
  }

  if (Number.isFinite(dollars) && Number.isFinite(cents)) {
    return dollars * 100 + cents;
  }

  return undefined;
}

export function formatAmount(locale: string, value: number): string {
  const valueWithDecimals = value / 100;

  return new Intl.NumberFormat(
    locale,
    valueWithDecimals % 1 === 0
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2 }
  ).format(valueWithDecimals);
}

export function currencySymbol(locale: string, currency: string): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(7)
    .replace(/7/g, "")
    .trim();
}
